import axiosInstance from "../config/axios";
import HttpService from "./httpService";

export type ReportStatus = "PENDING" | "PROCESSING" | "COMPLETED" | "FAILED";

export interface OrderReportFilters {
  dateFrom?: string;
  dateTo?: string;
  status?: string;
}

export interface OrderReport {
  id: string;
  entityId: number;
  type: "ORDER_ITEMS";
  status: ReportStatus;
  filters: OrderReportFilters;
  fileName: string;
  rowCount: number;
  errorMessage?: string;
  createdAt: string;
  updatedAt: string;
  completedAt?: string;
}

export class ReportService {
  static createOrderReport = async (filters: OrderReportFilters) => {
    return HttpService.post<OrderReport>("/reports/orders", filters);
  };

  static getReports = async () => {
    return HttpService.get<OrderReport[]>("/reports");
  };

  static downloadReport = async (report: OrderReport) => {
    const response = await axiosInstance.get(`/reports/${report.id}/download`, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = report.fileName || "order-report.xlsx";
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };
}
